import React from "react";
import Navbar from "./components/navbar/Navbar";

import {About, Footer, Header, Skill, Work, Testimonial} from "./container";

import "./app.scss";

function App(){
    return(
        <div className="app">
            <Navbar />
            <Header />
            <About />
            <Work />
            <Skill />
            <Testimonial />
            <Footer />
        </div>
    )
}

export default App;